<template>
  <v-content id="employers"></v-content>
</template>

<script>
import { mapGetters } from 'vuex'

// Vue Component
export default {
  created() {
    window.location.replace('https://about.leap.ly/')
  },
  computed: mapGetters({ role: 'auth/role' }),
}
</script>

<style>
main#employers {
  padding-top: 0 !important;
}
</style>
